// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yQJubOpPChEF72qimgSh{flex-direction:column;gap:3px;display:flex}.q8oLaCDOPGEMCdtl9Fy7{color:var(--content-primary-tertiary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `yQJubOpPChEF72qimgSh`,
	"headerDescription": `q8oLaCDOPGEMCdtl9Fy7`
};
export default ___CSS_LOADER_EXPORT___;
